<template>
  <div class="side-menu">
    <el-input 
      v-model="searchFileName" 
      size="large" 
      placeholder="输入关键字搜索" 
      style="width: 80%;margin:0 5% 20px 5%" 
    />
    <ul>
      <li 
        v-for="item in filteredMenuItems" 
        :key="item.id" 
        @click="selectMenu(item)"
        :class="{ active: selectedItem === item.id }"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
// 导入组件
import UploadFileView from './UploadFile.vue'
import IndexView from '../views/IndexView.vue'
import PictureCompressionView from './PictureCompression.vue'
import ColorPickerView from './ColorPicker.vue'
import CoverMaker from './CoverMark.vue'
import Base64ConverterView from './tools/Base64Converter.vue'
import MD5EncryptorView from './tools/MD5Encryptor.vue'
import URIEncoderDecoderView from './tools/URIEncoderDecoder.vue'

export default {
  name: 'SideMenu',
  
  // 定义组件接收的事件
  emits: ['menu-click'],
  
  data() {
    return {
      // 菜单项数据
      menuItems: [
        { id: 1, title: '首页', component: IndexView },
        { id: 2, title: '文件上云', component: UploadFileView },
        { id: 3, title: '图片压缩转换', component: PictureCompressionView },
        { id: 4, title: '取色板', component: ColorPickerView },
        { id: 5, title: '封面图制作', component: CoverMaker },
        { id: 6, title: 'Base64编码/解码', component: Base64ConverterView },
        { id: 7, title: 'MD5加密数值', component: MD5EncryptorView },
        { id: 8, title: 'URI编码/解码', component: URIEncoderDecoderView },
      ],
      // 当前选中的菜单项ID
      selectedItem: 1,
      // 搜索关键词
      searchFileName: ''
    }
  },
  
  computed: {
    // 过滤后的菜单项
    filteredMenuItems() {
      // 如果没有搜索词，返回所有菜单项
      if (!this.searchFileName.trim()) {
        return this.menuItems
      }
      
      // 模糊搜索：不区分大小写，匹配标题
      const searchTerm = this.searchFileName.toLowerCase()
      return this.menuItems.filter(item => 
        item.title.toLowerCase().includes(searchTerm)
      )
    }
  },
  
  methods: {
    // 选择菜单项
    selectMenu(item) {
      this.selectedItem = item.id
      if (item.component) {
        this.$emit('menu-click', item.component)
      }
    }
  }
}
</script>

<style scoped>
.side-menu {
  width: 15%;
  background-color: #34495e;
  color: white;
  padding: 1rem 0;
}

.side-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.side-menu li {
  padding: 0.8rem 1.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.side-menu li:hover {
  background-color: #2c3e50;
}

.side-menu li.active {
  background-color: #16a085;
  font-weight: bold;
}
</style>